import { z } from "zod";

export const DeliveryOptionSelectionSchema = z.object({
  id: z.number(),
  deliveryId: z.number(),
  optionId: z.number(),
  optionCode: z.string(),
  name: z.string(),
  clientPrice: z.number().nullable(),
  driverReportedAmount: z.number().nullable().optional(),
  files: z.string().nullable().optional(),
  input: z.string().nullable().optional(),
  requireInput: z.boolean().optional(),
  requiresFile: z.boolean().optional(),
  fileType: z.string().nullable().optional(),
  createdAt: z.iso.datetime(),
});

export type DeliveryOptionSelection = z.infer<typeof DeliveryOptionSelectionSchema>;
